export default __webpack_public_path__ + "d3b7f5223eef716ab06dcc7db5a11dfc.svg";